import React, { useState, useEffect, useContext } from 'react'

import LoadingContext from '../../context/Loading/Loading'
import AuthService from '../../utilities/services/auth.service'
import UserContext from '../../context/User/User'

import { getSales } from '../../utilities/api'
import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { checkPermission } from '../../utilities/helpers'

import Card from 'react-bootstrap/Card'

import { PageLoadingContainer } from './../PageLoadingContainer'
import { PrimaryTickets } from './PrimaryTickets'
import { EmptyContainer } from './../EmptyContainer'
import { NoPermissionsContainer } from '../NoPermissionsContainer'

export default function PrimaryTicketsWrapper({ eventId }) {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  const { orgPermissions } = useContext(UserContext)

  const { getPermissions, isSuperAdminOrganizer } = AuthService

  const orgPermissionsReady = orgPermissions?.length > 0
  const isSuperAdmin = isSuperAdminOrganizer()
  const hasPermission =
    isSuperAdmin ||
    (orgPermissionsReady &&
      checkPermission(
        getPermissions(),
        ORGANIZATION_PERMISSION_SLUGS.TICKET_SALES
      ))

  const [tickets, setTickets] = useState([])

  const [capacity, setCapacity] = useState(0)

  const [ticketsRemaining, setTicketsRemaining] = useState(0)

  useEffect(() => {
    if (!orgPermissionsReady && !isSuperAdmin) return
    if (!hasPermission) {
      hideLoading()
      return
    }

    sales()
  }, [orgPermissionsReady, hasPermission, isSuperAdmin, eventId])

  const sales = () => {
    showLoading()
    getSales(eventId, 'primary')
      .then((res) => {
        setTickets(res.data.tickets)
        setCapacity(res.data.capacity)
        setTicketsRemaining(res.data.ticketsRemaining)
        hideLoading()
      })
      .catch((err) => {
        console.error(err)
        hideLoading()
      })
  }

  if (!orgPermissionsReady && !isSuperAdmin) {
    return <PageLoadingContainer />
  }

  if (!hasPermission) {
    return <NoPermissionsContainer />
  }

  if (isLoading) {
    return <PageLoadingContainer />
  }

  return (
    <>
      <div className="position-relative">
        <section className="max-width-wrapper">
          <header className="section-header">
            <div className="section-header">
              <div className="section-heading">
                <h1>Primary tickets</h1>
              </div>
              <p className="section-header-desc">
                Report generated from when sales started
              </p>
            </div>
          </header>
          {tickets?.length > 0 ? (
            <PrimaryTickets
              tickets={tickets}
              capacity={capacity}
              ticketsRemaining={ticketsRemaining}
            />
          ) : (
            <Card body>
              <EmptyContainer style=" center lg">
                <p>There are no primary tickets sold for this event.</p>
              </EmptyContainer>
            </Card>
          )}
        </section>
      </div>
    </>
  )
}
